import * as React from "react";

import SvgAssetsEmptyState from "@svg/empty-assets";

export const EmptyState: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return (
    <div className="flex w-full flex-1 flex-col pb-5">
      <div className="bg-sheet border-0.5 border-border flex h-full flex-col items-center justify-center gap-3 rounded-sm border-dashed p-5">
        <SvgAssetsEmptyState />
        <div className="text-muted text-center text-sm">{children}</div>
      </div>
    </div>
  );
};
